export const toValidNumber = (value: unknown): number => {
  const num = Number(value);
  return Number.isNaN(num) ? 0 : num;
};
